import React, { useMemo } from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

import { useLanguagesList } from 'hooks/graphql/useLanguagesList.js';
import useLocale from 'hooks/useLocale';

import * as styles from './langSwitch.module.scss';

const LangSwitch = () => {
  const { defaultLanguage, languages } = useLanguagesList();

  const locale = useLocale();

  const languagesClear = useMemo(
    () => [
      {
        ...defaultLanguage,
        path: '',
      },
      ...languages
        .filter((language) => language.code !== defaultLanguage.code)
        .map((language) => ({
          ...language,
          path: language.slug,
        })),
    ],
    [defaultLanguage, languages]
  );

  const currentLang = useMemo(
    () => languagesClear.find((language) => language.code !== locale.code),
    [languagesClear, locale.code]
  );

  return (
    <div className={classnames(styles.lang)}>
      <span className={classnames(styles.inner, 'cr-text-2 ct-txt-up')}>
        <Link to={`/${currentLang.path}`}>{currentLang.code}</Link>
      </span>
    </div>
  );
};

export default LangSwitch;
